import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Divider from '@/components/common/Divider';
import { breakpointsMediaQuery, useMediaQuery } from '@/helpers/utils';
import type { FilterColumn, SelectFilterColumnProps } from './filterTypes';

const SelectFilterColumn = ({
  columns,
  advancedFilters,
  setAdvancedFilters
}: SelectFilterColumnProps) => {
  const [, setShow] = useState(false);
  const uniqueColumnGroups = [...new Set(columns.map(item => item.gp))];

  const handleShowColumns = () => {
    setShow(current => !current);
  };

  const handleSelectColumn = (column: FilterColumn) => {
    if (!column.field) {
      return;
    }

    setShow(false);
    const updatedFilters = { ...advancedFilters };
    updatedFilters[column.field] = {
      title: column.title ?? '',
      operator: 'and',
      filterModes: []
    };

    setAdvancedFilters(updatedFilters);
  };
  const isLgUp = useMediaQuery(breakpointsMediaQuery.lg);

  return (
    <>
      <OverlayTrigger
        trigger="click"
        rootClose={true}
        placement={isLgUp ? 'right' : 'bottom-end'}
        overlay={
          <Popover>
            <Popover.Body
              className="overflow-auto"
              style={{ maxHeight: '500px' }}
            >
              {uniqueColumnGroups.map((group, index) => {
                return (
                  <div key={index}>
                    <h6>{group}</h6>
                    <ul>
                      {columns
                        .filter(
                          item =>
                            Boolean(item.field) &&
                            !Object.keys(advancedFilters).includes(
                              item.field!
                            ) &&
                            item.gp === group
                        )
                        .map((item, index) => {
                          return (
                            <li className="mb-1" key={index}>
                              <a
                                className="text-800 d-block cursor-pointer"
                                onClick={() => handleSelectColumn(item)}
                                key={index}
                              >
                                {item.title}
                              </a>
                            </li>
                          );
                        })}
                    </ul>
                    {uniqueColumnGroups.length - 1 !== index && (
                      <Divider className="my-0 p-0" />
                    )}
                  </div>
                );
              })}
            </Popover.Body>
          </Popover>
        }
      >
        <Button
          size={isLgUp ? 'lg' : 'sm'}
          onClick={() => handleShowColumns()}
          variant="outline-primary"
          style={{
            height: '36px'
          }}
          className="fs-0 mt-xxl-0"
        >
          <span className="d-flex align-items-center gap-1">
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline">فیلتر بیشتر</span>
          </span>
        </Button>
      </OverlayTrigger>
    </>
  );
};

export default SelectFilterColumn;
